<template>
  <div class="pa-6">
    <div class="d-flex justify-space-between align-center mb-6">
      <div class="component-title">Quản lý xếp lớp - Khối 10</div>
      <DocumentExcelExport v-show="!canViewOnly" />
    </div>
    <v-card class="pa-6 elevation-1 mb-6">
      <DocumentFilter @onFilterChanged="onFilterChanged" />
    </v-card>
    <v-card class="elevation-1">
      <DocumentTable ref="documentTable" />
    </v-card>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import DocumentFilter from './ListFilter.vue'
import DocumentTable from './ListTable.vue'
import DocumentExcelExport from './ExcelExport.vue'
export default {
  components: {DocumentFilter, DocumentTable, DocumentExcelExport},
  computed: {
    ...mapGetters('auth', ['user']),
    canViewOnly() {
      return this.user.username === 'uyenpt'
    },
  },
  async mounted() {
    let query = {type: 'Khối 10'}
    if (this.user.department === 'both') query.department_in = ['Cơ sở A', 'Cơ sở 1', 'unset']
    else query.department_in = [this.user.department, 'unset']
    await this.countItems(query)
  },
  methods: {
    ...mapActions({fetchItems: 'assignClass/fetchItems', countItems: 'assignClass/countItems'}),
    async onFilterChanged(data) {
      this.$loading.active = true
      const params = {...data, type: 'Khối 10'}
      await this.fetchItems({...params, _start: 0, _limit: 10})
      await this.countItems(params)
      this.$loading.active = false
    },
  },
  async beforeDestroy() {
    await this.resetState()
  },
}
</script>
<style scoped>
.component-title {
  color: #0d47a1;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 28px;
}
</style>
